import React from 'react';

class MovieDetailsDescriptionSdh extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      inclusiveAadaptation: undefined
    };

    this.setInclusiveAadaptation = this.setInclusiveAadaptation.bind(this);
  }

  setInclusiveAadaptation(obj) {
    this.setState({ inclusiveAadaptation: obj });
  }

  componentDidMount() {
    fetch('/json_settings/custom_settings.json')
      .then(resp => {
        return resp.json()
      })
      .then(obj => {
        this.setInclusiveAadaptation(obj)
      })
  }

  getText() {
    let str = ''
    if (this.state.inclusiveAadaptation) {
      const text = this.state.inclusiveAadaptation.movie_page.details.inclusive_adaptation.html_text
      const variable = this.state.inclusiveAadaptation.movie_page.details.inclusive_adaptation.variable_description_sdh

      str = text.replaceAll(variable, this.props.film.DescriptionSDH)
    }

    return str
  }

  getFindedAppSettings() {
    // Може бути 'Subcatch, Earcatch'
    const listAppFromAdmin = this.props.film.DescriptionSDH.split(',').map(_ => _.trim())
    const findedAppSettings = []

    listAppFromAdmin.forEach(appName => {

      // Знайти об'єкти для рендеренгу. В JSON шукаються параметри для назви додатку appName
      const findApp = this.state
        .inclusiveAadaptation
        .movie_page
        .details
        .section_application
        .filter(app => app.application_name.toLowerCase() === appName.toLowerCase())

      findedAppSettings.push(...findApp)
    })

    return findedAppSettings
  }

  render() {

    // Якщо немає обох параметрів - повертаємо null
    if (!(this.props.film.DescriptionSDH && this.state.inclusiveAadaptation)) {
      return null
    }

    const text = this.getText()
    const findedAppSettings = this.getFindedAppSettings()

    return (
      <React.Fragment>
        <li className="mvi__kv">
          <p className="mvi__key">Інклюзивна адаптація:</p>
          <div className="mvi__val">
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        </li>

        {
          findedAppSettings.map((section, idx) => {
            return (
              <li key={idx} className="mvi__kv mvi__kv__dt_flex mt-dt-8">
                <p className="mvi__key" ></p>

                <div className="wrap-mob-app">
                  <p className='sertificat__text__paragraph font-bold'>{section.header}</p>

                  {section.applications.map((app, idxApp) => {
                    return (
                      <a key={idxApp} className="mob-app" target="_blank" href={app.path_to_app} style={{ marginBottom: 0 }}>
                        <img src={app.path_to_img} alt={app.img_alt_text} />
                      </a>
                    )
                  })}
                </div>
              </li>
            )
          })
        }

        {/* Цей блок лише для нижнього відступу в мобільном вигляді як у інших блоків "Властивості фільму" */}
        <li className="mvi__kv">
          <p className="mvi__key" />
          <div className="mvi__val" />
        </li>
        {/* Цей блок лише для нижнього відступу в мобільном вигляді як у інших блоків "Властивості фільму" */}


      </React.Fragment>
    )

  }
}

export default MovieDetailsDescriptionSdh


// WEBPACK FOOTER //
// ./src/components/pages/MoviePage/impl/MovieDetails/MovieDetailsDescriptionSdh.jsx